
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSafetySettingsProposal as ObiChartSafetySettingsProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-safety-settings-proposal.js';
 
 
 

 
 export const ObiChartSafetySettingsProposal = createComponent({
   react: React,
   tagName: 'obi-chart-safety-settings-proposal',
   elementClass: ObiChartSafetySettingsProposalElement,
   events: {
     
   }
  });
 
 